import axios from 'axios';
import { ACCESS_TOKEN } from './constants';
import { isEmpty } from './util.services';
axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
axios.interceptors.response.use(
    (response) => {
        return response ? response.data instanceof Blob ? response : response.data : response
    }, (error) => {
        const data = error.response ? error.response.data : error;
        return Promise.reject(data);
    });

const getAuthHeader = () => {
    return {
        'Accept': 'application/json, text/plain, */*',
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        'Content-Type': 'application/json'
    };
};

const headers = {
    'Accept': 'application/json, text/plain, */*',
    'Content-Type': 'application/json'
};

const getAuthHeaderFile = () => {
    return {
        'Accept': 'application/json, text/plain, */*',
        'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN),
        'Content-Type': 'multipart/form-data'
    };
}

function executeHttpCall(callable: any, appContext: any, success: any, error: any, hideErrorMsg?: any){
    appContext.setShowLoader && appContext.setShowLoader(true);
    callable.then((response: any) => {
        if(response) {
            appContext.setShowLoader && appContext.setShowLoader(false);
            appContext.setSuccessMessage && appContext.setSuccessMessage(response.message);
            if(success) {
                success(response);
            }
        }
    }).catch((err: any) => {
        appContext.setShowLoader && appContext.setShowLoader(false);
        appContext.setErrorMessage && appContext.setErrorMessage(err.message);
        if(error){
            error(err);
        }
    })
}

function handleError() {
    if (isEmpty(localStorage.getItem(ACCESS_TOKEN))) {
        console.log('No access token set.')
        return Promise.reject('No access token set.');
    }
}

export function get(url: string, appContext: any, success: any, error: any) {
    handleError();
    const options = {
        headers: getAuthHeader()
    };

    return executeHttpCall(axios.get(url, options), appContext, success, error);
}

export function whitelistGet(url: string, appContext: any, success: any, error: any) {
    let header = headers;
    if (localStorage.getItem(ACCESS_TOKEN)) {
        header = getAuthHeader();
    }
    const options = {
        headers: header
    };

    return executeHttpCall(axios.get(url, options), appContext, success, error);
}

export function post(url: string, data: any, appContext: any, success: any, error: any) {
    handleError();
    const options = {
        headers: getAuthHeader()
    };
    return executeHttpCall(axios.post(url, data, options), appContext, success, error);
}

export function postfile(url: string, data: any, appContext: any, success: any, error: any) {
    handleError();
    const options = {
        headers: getAuthHeaderFile()
    };
    return executeHttpCall(axios.post(url, data, options), appContext, success, error);
}

export function put(url: string, data: any, appContext: any, success: any, error: any) {
    handleError();
    const options = {
        headers: getAuthHeader()
    };
    return executeHttpCall(axios.put(url, data, options), appContext, success, error);
}

export function whitelistPost(url: string, data: any, appContext: any, success: any, error: any) {
    let header = headers;
    if (localStorage.getItem(ACCESS_TOKEN)) {
        header = getAuthHeader();
    }
    const options = {
        headers: header
    };
    return executeHttpCall(axios.post(url, data, options), appContext, success, error);
}

export function remove(url: string, appContext: any, success: any, error: any) {
    handleError();
    const options = {
        headers: getAuthHeader()
    };
    return executeHttpCall(axios.delete(url, options), appContext, success, error);
}

export function whitelistRemove(url: string, appContext: any, success: any, error: any) {
    let header = headers;
    if (localStorage.getItem(ACCESS_TOKEN)) {
        header = getAuthHeader();
    }
    const options = {
        headers: header
    };
    return executeHttpCall(axios.delete(url, options), appContext, success, error);
}
